module.exports = {
	"id": "NL",
	"name": "Netherlands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.018114,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006038,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.012076,
			"23": null,
			"24": 0.018114,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012076,
			"30": null,
			"31": 0.066418,
			"32": 0.012076,
			"33": 0.018114,
			"34": 0.012076,
			"35": 0.018114,
			"36": 0.012076,
			"37": 0.03019,
			"38": 0.036228,
			"39": 0.06038,
			"40": 0.03019,
			"41": 0.042266,
			"42": 0.042266,
			"43": 0.102646,
			"44": 0.048304,
			"45": 0.048304,
			"46": 0.048304,
			"47": 0.06038,
			"48": 0.229444,
			"49": 1.159296,
			"50": 0.193216,
			"51": 0.718522,
			"52": 0.42266,
			"53": 20.89148,
			"54": 5.422124,
			"55": 0.054342,
			"56": 0.018114,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006038,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.012076,
			"17": null,
			"18": null,
			"19": 0.012076,
			"20": 0.042266,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006038,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006038,
			"29": 0.012076,
			"30": 0.012076,
			"31": 0.024152,
			"32": 0.018114,
			"33": 0.018114,
			"34": 0.024152,
			"35": 0.024152,
			"36": 0.024152,
			"37": 0.018114,
			"38": 0.096608,
			"39": 0.036228,
			"40": 0.03019,
			"41": 0.036228,
			"42": 0.072456,
			"43": 0.114722,
			"44": 0.084532,
			"45": 0.307938,
			"46": 0.175102,
			"47": 0.567572,
			"48": 0.531344,
			"49": 6.545192,
			"50": 0.09057,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.012076
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.018114,
			"35": null,
			"36": 0.024152,
			"37": 0.018114,
			"38": 0.084532,
			"39": 0.012076,
			"40": 0.440774,
			"41": 0.114722,
			"42": 0.018114,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03019
		},
		"safari": {
			"0": null,
			"4": 0.006038,
			"5": 0.042266,
			"6": 0.006038,
			"7": 0.036228,
			"8": 0.235482,
			"9": 0.326052,
			"10": 2.469542,
			"3.1": null,
			"3.2": null,
			"5.1": 0.132836,
			"6.1": 0.078494,
			"7.1": 0.012076,
			"9.1": 1.497424
		},
		"ios_saf": {
			"8": 0,
			"10": 9.68824980683,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.261087121774,
			"8.1-8.4": 0.482347394463,
			"9.0-9.2": 0.230110683597,
			"9.3": 3.51066299334
		},
		"android": {
			"3": 0,
			"4": 0.0265806640827,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00332258301034,
			"4.1": 0.095880252584,
			"4.2-4.3": 0.23970063146,
			"4.4": 0.549650160853,
			"4.4.3-4.4.4": 0.55439670801
		},
		"ie": {
			"6": 0.0121367597484,
			"7": 0.0121367597484,
			"8": 0.175983016352,
			"9": 0.315555753459,
			"10": 0.242735194969,
			"11": 8.89017651572,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0232186882106,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000644963561404
		},
		"edge": {
			"12": 0.132836,
			"13": 0.929852,
			"14": 3.218254
		},
		"ie_mob": {
			"10": 0.0765421408451,
			"11": 0.311635859155
		},
		"bb": {
			"7": 0.0099025,
			"10": null
		},
		"samsung": {
			"0": 6.163316
		},
		"and_uc": {
			"0": 1.053626
		},
		"op_mini": {
			"0": 0.312821348228
		},
		"and_chr": {
			"0": 16.708059
		},
		"and_ff": {
			"0": 0.055454
		}
	},
	"total": 98.7144795
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NL.json
 ** module id = 610
 ** module chunks = 0
 **/